import { entity, clearDirty } from "./base";
import utility, { concatModules } from "@/utility";

const initialEntity = {
  current_password: "",
  new_password: "",
  new_password_confirmation: ""
};

const passwordModule = {
  actions: {
    update({ commit }, { pk, updatedEntity, formKeys = [] }) {
      commit("processing");

      return new Promise((resolve, reject) => {
        this.$axios // axios
          .put(`/administrators/${pk}/password`, updatedEntity) // put
          .then(() => {
            clearDirty(commit, formKeys);
            commit("processed");

            utility.$message({
              type: "success",
              message: "更新しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", {
              response: error.response
            });

            reject(error);
          });
      });
    },
    show({ commit }) {
      return new Promise((resolve) => {
        commit("succeeded", {
          entity: { ...initialEntity }
        });
        resolve();
      });
    }
  }
};

const entityModule = entity("password", initialEntity);

export const password = {
  namespaced: true,
  modules: {
    entity: concatModules(entityModule, passwordModule)
  }
};
